module.exports = __webpack_public_path__ + "img/20170704_135648_087.dc1de26b.jpg";